import { render, staticRenderFns } from "./TextRecommendationModule.vue?vue&type=template&id=ce79254c&scoped=true"
import script from "./TextRecommendationModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationModule.vue?vue&type=style&index=0&id=ce79254c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce79254c",
  null
  
)

export default component.exports